import { render } from "./ui-rangeslider.vue?vue&type=template&id=c4b24ec8"
import script from "./ui-rangeslider.vue?vue&type=script&lang=js"
export * from "./ui-rangeslider.vue?vue&type=script&lang=js"

import "./ui-rangeslider.vue?vue&type=style&index=0&id=c4b24ec8&lang=css"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__